// src/pages/NewTeam.tsx
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AdminLayout from '../components/layout/AdminLayout';
import TeamForm from '../components/forms/TeamForm';
import { createTeamMember } from '../services/TeamService';
import { ITeamMember } from '../types/Team';
import { useToast } from '../hooks/useToast'; // 🔥 Importar el hook
import styles from '../styles/FormPages.module.css';

const NewTeam: React.FC = () => {
  const navigate = useNavigate();
  const toast = useToast(); // 🔥 Usar el hook

  const handleSubmit = async (formData: ITeamMember) => {
    try {
      const { id, ...memberData } = formData;

      const dataToSubmit = {
        ...memberData,
        imageUrl: memberData.imageUrl || 'https://via.placeholder.com/400x400.png?text=Miembro+Equipo',
        order: memberData.order || 0,
        isActive: memberData.isActive ?? true,
        isFeatured: memberData.isFeatured ?? false
      };

      await createTeamMember(dataToSubmit);
      
      // 🔥 Reemplazar alert por toast
      toast.success(
        'Miembro creado', 
        `"${memberData.firstName} ${memberData.lastName}" ha sido agregado al equipo.`
      );
      
      navigate('/team');
    } catch (error: any) {
      console.error("Error al crear miembro:", error);
      // 🔥 Toast de error
      toast.error(
        'Error al crear miembro',
        error.message || 'No se pudo crear el miembro del equipo.'
      );
    }
  };

  return (
    <AdminLayout pageTitle="Agregar Nuevo Miembro">
      <div className={styles.formWrapper}>
        <div className={styles.pageHeader}>
          <h2 className={styles.title}>Agregar Nuevo Miembro</h2>
          <Link to="/team" className={styles.backButton}>
            ← Volver al Equipo
          </Link>
        </div>
        
        <TeamForm onSubmit={handleSubmit} isEditing={false} />
      </div>
    </AdminLayout>
  );
};

export default NewTeam;